import { useNavigate } from 'react-router-dom';
import { Alert, AlertTitle } from '@mui/material';
import Grid from '@mui/material/Grid';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PropTypes from 'prop-types';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';

export default function ErrorFallback({ error, resetErrorBoundary = () => {} }) {
  const navigate = useNavigate();
  return (
    <Alert
      severity="error"
      sx={{
        '& .MuiAlert-message': {
          width: '100%'
        }
      }}
    >
      <AlertTitle>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item>
            <MDTypography variant="h4" color="error">
              Error: {error.message}
            </MDTypography>
          </Grid>
          <Grid item>
            <MDButton
              variant="outlined"
              iconOnly
              color="error"
              onClick={() => {
                resetErrorBoundary();
                navigate('/redirectHome');
              }}
            >
              <ArrowBackIcon />
            </MDButton>
          </Grid>
        </Grid>
      </AlertTitle>
      {error.stack && (
        <MDBox sx={{ margin: 'auto', textAlign: 'left' }}>
          <MDTypography variant="body2" color="error">
            <pre>{error.stack}</pre>
          </MDTypography>
        </MDBox>
      )}
    </Alert>
  );
}

ErrorFallback.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
    stack: PropTypes.string
  }).isRequired,
  resetErrorBoundary: PropTypes.func
};

ErrorFallback.defaultProps = {
  resetErrorBoundary: () => {}
};
